import { render } from "./App.vue?vue&type=template&id=69025012"
const script = {}

import "./App.vue?vue&type=style&index=0&id=69025012&lang=css"
script.render = render

export default script